import React from 'react'
import Navigation from './Navigation'
import { Route, withRouter } from 'react-router-dom'
import { addLocaleData, IntlProvider } from 'react-intl'

import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'

import messages from '../../messages'
import { BgDD } from './styles'
import { checkJapanese, flattenMessages, checkMobile,checkPad } from '../../lib'
import { checkIftokenExists } from '../authenticateHOC'
import AppBar from './AppBar'
import config from '../../config/config'
import Maintenance from '../../layouts/LoggedIn/Maintenance'

// Language dependencies
addLocaleData([...en, ...ja])

//
class Layout extends React.Component  {
  state = {
    trial: false,
    signupLoading: true
  }

  setTrial = (trial) => {
    this.setState({
      trial,
      signupLoading: false
    })
  }
  render() {
    const {component: Component, path, ...rest} = this.props

    return (
      <Route
        {...rest}
        render={matchProps => (
          <IntlProvider
            locale={checkJapanese() ? 'ja' : 'en'}
            messages={flattenMessages(
              messages[checkJapanese() ? 'ja' : 'en']
            )}>
              <div style={{height:'100%'}}>
              {this.state.trial && <AppBar/>}
              
              {rest.isCheckingToken || (path === "/signup" && this.state.signupLoading) && (
                <div className="min-h-inherit w-100 flex justify-center items-center" style={{position: 'absolute', top: 0, bottom: 0, background: '#ffffff', zIndex: 9999}}>
                Loading...
              </div>) }
              {config.IS_MAINTENANCE ?  <Maintenance/> : (
                 <BgDD className="min-h-inherit w-100" trial={ this.state.trial}>
                 <div className={(!checkMobile()) &&  "min-h-inherit w-100 pt3 pr5 pl5" }>
                   <Navigation {...rest} />
                   <div>
                     <Component {...matchProps} setTrial={this.setTrial} />
                   </div>
                 </div>
                 </BgDD>
              ) }
               
            </div>
          </IntlProvider>
        )}
      />
    )
  }
}

export default withRouter(checkIftokenExists(Layout))



// WEBPACK FOOTER //
// src/layouts/LoggedOut/Layout.js